import { useEffect, useState } from "react";
import { api, formatApiError } from "@/context/AuthContext";

export default function LearnerTrainingOutcomeCard({ programmeId = "programme-nz-road-code" }) {
  const [outcome, setOutcome] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/training-outcomes/learner/me", { params: { programme_id: programmeId } })
      .then((res) => setOutcome(res.data?.outcome))
      .catch((err) => setError(formatApiError(err)));
  }, [programmeId]);

  if (error) return null;
  if (!outcome) return null;

  const statusLabel =
    outcome.training_status === "completed"
      ? "Completed"
      : outcome.training_status === "paused"
        ? "Paused"
        : "In progress";

  return (
    <section className="card space-y-2" data-testid="learner-training-outcome">
      <h2 className="text-base font-semibold">Your training record</h2>
      <p className="text-sm">Training status: <strong>{statusLabel}</strong></p>
      {outcome.licence_stage && (
        <p className="text-sm">Licence stage recorded: {outcome.licence_stage}</p>
      )}
      {outcome.achievement_date && (
        <p className="text-sm text-muted-foreground">Achievement date: {outcome.achievement_date}</p>
      )}
      {outcome.instructor_confirmed_outcome && (
        <p className="text-sm">{outcome.instructor_confirmed_outcome}</p>
      )}
      {outcome.next_steps && (
        <p className="text-sm text-muted-foreground">Next steps: {outcome.next_steps}</p>
      )}
    </section>
  );
}
